import { useEffect, useState } from "react";
import api, { ApiError } from "../utils/api";

/**
 * Fetches the public event list for a given scope ("upcoming" or "past").
 * Exposes loading/error/empty states so pages can render them consistently.
 */
export default function useEvents(scope = "upcoming") {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError(null);

    api
      .listEvents(scope)
      .then((data) => {
        if (!cancelled) {
          setEvents(data.events || []);
        }
      })
      .catch((err) => {
        if (!cancelled) {
          setError(err instanceof ApiError ? err.message : "Unable to load events right now.");
        }
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [scope]);

  return { events, loading, error };
}
